module.exports = __webpack_public_path__ + "static/img/duibimingandu.8f0d80f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/duibimingandu.png
// module id = C6YF
// module chunks = 3